module.exports = __webpack_public_path__ + "img/Addresses.e02ad4b8.png";